import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';


import * as styleUtils from '../../../../utils/styleUtils';
import * as urlUtils from '../../../../utils/urlUtils';

import hasRole from '../../../contexts/Auth/hooks/hasRole';

import {authConstants} from '../../../contexts/Auth';
import {cartConstants, cartSelectors} from '../../../contexts/Cart';

import {Icon, iconConstants} from '../../Icon';
import {I18nMessage} from '../../../contexts/I18n';
import {NavLink} from 'react-router-dom';

import styles from './CartLink.scss';


function CartLink({}) {

    const {formatMessage} = useIntl();

    const areCartsLoaded = useSelector(cartSelectors.areCartsLoaded);
    const cartId = useSelector(cartSelectors.getActiveCartId);
    const totalCartItems = useSelector(cartSelectors.getActiveCartTotalItems);

    const hasCartFeatureRole = hasRole(authConstants.ROLE_FEATURE_CART);

    if (!areCartsLoaded || !hasCartFeatureRole) {

        return null;
    }

    return (
        <li className={styles.cartWrap}>
            <NavLink
                className={({isActive}) => styleUtils.toClasses(styles.cart, isActive ? styles.active : null)}
                aria-current={'page'}
                aria-label={formatMessage({id: 'main.nav.cart.label'})}
                to={urlUtils.buildPath(cartConstants.NAV_PAGE_CART, {cartId})}
            >
                <I18nMessage id={'main.nav.cart.label'}/>

                <div className={styles.cartIconBadge}>

                    <div className={styles.cartBadge}>
                        {totalCartItems}
                    </div>
                    <Icon icon={iconConstants.ICON_CART}/>

                </div>
            </NavLink>
        </li>
    );
}


export default CartLink;
